<template>
  <div class="community-warpper">
    <div class="bg-white ">
      <div class="margin-bottom-sm flex align-center justify-between">
        <div class="flex align-center">
          <div class="flex align-center margin-right-sm">
            <span>小区：</span>
            <el-input v-model="searchName" placeholder="请输入小区名称" class="flex-sub"></el-input>
          </div>
          <div class="flex align-center margin-right-sm">
            <span>状态：</span>
            <el-select v-model="status" placeholder="请选择状态" class="flex-sub">
              <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <el-button type="primary" @click="hanldSearch">搜索</el-button>
        </div>
        <el-button type="primary" @click="communityDialog = true">新增小区</el-button>
      </div>
      <el-table
          :data="communityList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          border
          style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号">
        </el-table-column>
        <el-table-column label="社区名称" prop="xiangmu_name"></el-table-column>
        <el-table-column label="小区名称" prop="name"></el-table-column>
        <el-table-column label="社区负责人" prop="xiangmujingli_name"></el-table-column>
        <el-table-column label="联系电话" prop="xiangmujingli_phone"></el-table-column>
        <el-table-column label="创建时间" prop="create_time"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div>
              {{ scope.row.status === 1 ? "正常" : "停用" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="beizhu"></el-table-column>
        <el-table-column label="操作" width="450">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                  size="small"
                  type="primary"
                  @click="editItem(scope.row)"
                  v-if="scope.row.status === 1"
              >编辑
              </el-button>
              <el-button
                  size="small"
                  type="primary"
                  @click="setLockItem(scope.row.id,2)"
                  v-if="scope.row.status === 1"
              >停用
              </el-button>
              <el-button
                  size="small"
                  type="success"
                  @click="setLockItem(scope.row.id,1)"
                  v-if="scope.row.status === 2"
              >启用
              </el-button>

              <el-button
                  size="small"
                  type="primary"
                  @click="detailItem(scope.row.id,scope.row.xiangmu_id,scope.row.name)"
                  v-if="scope.row.status === 1"
              >楼宇管理
              </el-button>
              <el-button size="small" type="primary" @click="setImg(scope.row)">社区照片</el-button>

<!--              <router-link :to="'/community?id=' + scope.row.id" class="margin-left-xs" target="_blank">-->
<!--                <el-button size="small" type="primary">数据统计</el-button>-->
<!--              </router-link>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          v-if="communityList.length > 0"
          class="page-all"
          background
          @current-change="xiaoQuList"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
    <communityDialog
        :setId="setId"
        :setItem="setItem"
        :communityDialog="communityDialog"
        @cancelDialog="cancelDialog"
    />

    <imgDialog
      :setId="setId"
      :setItem="setItem"
      :imgDialog="imgDialog"
      :type="2"
      @cancelDialog="cancelDialog"
    />


  </div>
</template>

<script>
import communityDialog from "@/views/pages/dialog/communityDialog";
import imgDialog from "@/views/pages/dialog/imgDialog";
import {zhDate} from "@/utils/utils";
import {xiaoQuList, setXiaoQuStatus} from "@/api/community";

export default {
  name: "community",
  data() {
    return {
      searchName: '',
      status: 0,
      statusList: [
        {value: 0, label: '全部'},
        {value: 1, label: '正常'},
        {value: 2, label: '停用'},
      ],
      page: 1,
      limit: 10,
      total: 0,
      communityList: [],
      setId: 0,
      setItem: {},
      communityDialog: false,
      imgDialog: false
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "系统管理 / 小区管理", false);
    this.xiaoQuList()
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  components: {
    communityDialog,
    imgDialog
  },
  methods: {
    setImg(obj){
      this.setItem = obj;
      this.setId = obj.id;
      this.imgDialog = true;
    },
    //  楼宇管理
    detailItem(cid, pid, name) {
      this.$router.push({
        path: `/home/floor-management/${cid}/${pid}`,
        query: {
          name: name
        }
      })
    },
    //  小区停用/启用
    setLockItem(id, state) {
      this.$confirm(state === 2 ? '您确定要停用该小区吗？' : '您确定要启用该小区吗', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureSetLock(id, state);
      });
    },
    async sureSetLock(id, state) {
      let _state = await setXiaoQuStatus(id, state);
      this.$message.success(_state.info);
      this.xiaoQuList();

    },
    //  编辑
    editItem(obj) {
      this.setItem = obj;
      this.setId = obj.id;
      this.communityDialog = true;
    },
    //  员工信息编辑后回调
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.communityDialog = false;
        this.imgDialog = false;
        this.xiaoQuList();
      } else {
        this.setId = 0;
        this.setItem = {};
        this.communityDialog = false;
        this.imgDialog = false;
      }
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.xiaoQuList()
    },
    //  获取列表
    async xiaoQuList() {
      let _list = await xiaoQuList(this.searchName, this.status, this.page, this.limit)
      _list.data.map(item => {
        item.create_time = zhDate(item.create_time * 1000)
      })
      this.communityList = _list.data
      this.total = _list.total_number
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
